import { BrowserView } from 'components/DeviceDetect'
import Loader from 'components/Loader'
import React from 'react'
import useConfig from 'store/ConfigProvider'
import useInnerPage from 'store/InnerPageProvider'
import {
  CategoryContainer,
  CategoryContent,
  CategoryMainContent,
} from 'style/Category.style'
import { DesktopHeaderCategories } from '../Widgets/Categories/Categories'
import InnerPageLeftSide from './components/InnerPageLeftSide'
import InnerPageRightSide from './components/InnerPageRightSide'

const InnerPage = props => {
  const {
    breadcrumb,
    backLink,
    backText,
    blocks,
    tiles,
    keyword,
    slug,
    category,
  } = props
  const { loading, sidebar } = useInnerPage()
  const { categories, topCategories } = useConfig()

  return (
    <CategoryContainer>
      <BrowserView>
        <DesktopHeaderCategories
          categories={categories}
          topCategories={topCategories}
        />
      </BrowserView>

      {loading && !sidebar.loaded ? (
        <Loader visible={true} type="ThreeDots" />
      ) : (
        <CategoryMainContent>
          <InnerPageLeftSide
            key={slug}
            backLink={backLink}
            backText={backText}
            slug={slug}
          />
          <CategoryContent>
            {loading && sidebar.loaded ? (
              <Loader visible={true} type="ThreeDots" />
            ) : (
              <InnerPageRightSide
                breadcrumb={breadcrumb}
                tiles={tiles}
                key={slug}
                slug={slug}
                blocks={blocks}
                keyword={keyword}
                category={category}
              />
            )}
          </CategoryContent>
        </CategoryMainContent>
      )}
    </CategoryContainer>
  )
}

export default InnerPage
